import {useFetchOneEntry} from '../useFetchOneEntry'
import builderConfig from 'hec/builder/model-map'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const useFetchModulePageUrl = ({moduleId}) => {
    const config = getConfig()
    const apiKey = config.app.builder.api
    const {data, ...rest} = useFetchOneEntry({
        queryKey: ['Builder-Fetch-Next-Module', moduleId],
        options: {
            model: builderConfig.learningCenterModule,
            apiKey: apiKey,
            query: {
                data: {
                    id: {$eq: moduleId}
                }
            },
            fields: 'data.page.value.data.url'
        },
        enabled: !!moduleId
    })

    const modulePageUrl = data?.data?.page?.value?.data?.url
    return {modulePageUrl, ...rest}
}

export default useFetchModulePageUrl
